export const getSx = ({ width, paperClasses }) => ({
  '&.MuiDrawer-root': {
    flexShrink: 0
  },
  '& .MuiPaper-root': {
    width,
    ...paperClasses
  }
});
